import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { TaskDTO, ActionTypeDTO } from '../api/plyca-dtos';
import { TaskService } from '../tasks/task.service';
import { TranslateService } from '@ngx-translate/core';
import { SignatureService } from '../../services/signature.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';

@Component({
  selector: 'taskProcurementCommittee',
  templateUrl: 'taskProcurementCommittee.template.html'
})
export class taskProcurementCommitteeComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input()
  layoutClass: string;

  // Referencia a la lista de tareas almacenada en el store
  filteredTasks: Array<TaskDTO>;

  loading = true;
  error = false;

  // CONTANTES PARA EL TEMPLATE (NO SE PUEDE ACCEDER DESDE UN TEMPLATE A contantes)
  TASK_UNLOCK: string;
  TASK_LOCK: string;

  constructor(
    private store: Store<AppState>,
    public taskService: TaskService,
    private signatureService: SignatureService,
    public translateService: TranslateService
  ) {
    super();
    this.subscribe(this.taskService.loadingStatusObservable, x => {
      this.loading = x;
    });
    this.TASK_UNLOCK = ActionTypeDTO.TASK_UNLOCK;
    this.TASK_LOCK = ActionTypeDTO.TASK_LOCK;
  }

  ngOnInit(): void {
    this.subscribe(this.store
      .select('pendingTasks'),
      (tasks: Array<TaskDTO>) => {
        if (tasks) {
          // TODO: Revisar filtro. Ahora mismo se filtran las tareas asociadas a perfil dinamico
          this.filteredTasks = tasks.filter(
            (t: TaskDTO) =>
              //              t.workAvailable && (t.profile && t.profile.identifier > 100)
              t.profile && t.profile.identifier > 100
          );
        }
        this.loading = false;
      });
  }

  isLoading(): boolean {
    return this.loading;
  }

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error;
  }

  // tslint:disable-next-line:member-ordering
  estadoFerramenta = '';
  // METODOS PARA COMPROBAR EL FUNCIONAMIENTO DE LA HERRAMIENTA DE LICITACION
  startFerramenta() {
    let startOnSuccess = function (messages: Array<string>): void {
      console.log('startOnSuccess');
      this.estadoFerramenta = 'Inicializada OK (' + messages + ')';
    }.bind(this);

    let startOnError = function (error: string, msgError: string): void {
      console.log('startOnError: [' + error + '] ' + msgError);
      this.estadoFerramenta = 'Error en la inicialización';
    }.bind(this);

    this.estadoFerramenta = 'Inicializando...';
    this.signatureService.startFerramenta(startOnSuccess, startOnError);
  }

  stopFerramenta() {
    let stopOnSuccess = function (b64Secrets: Array<string>): void {
      console.log('stopOnSuccess');
      this.estadoFerramenta = '';
    }.bind(this);
    this.signatureService.stopFerramenta(stopOnSuccess);
  }

  unlock(task: TaskDTO): void {
    this.subscribe(this.taskService.unlockTask(task));
  }
}
